import React from "react";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChalkboardTeacher,
    faCircle,
    faUpload,
    faExternalLinkAlt,
    faChevronLeft, faChevronDown, faFile, faCircleNotch, faSearch, faCheckCircle
} from "@fortawesome/free-solid-svg-icons";
import {Button, Card, Col, Row, Table} from "react-bootstrap";
import Collapsible from "react-collapsible";
import CamplaCoreService from "../../../services/CamplaCoreService";

class ExaminationTableItem extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            studentFileProposals: null,
            showStudentFileProposals: false
        }

        this.fileState = [
            <span className="fa-layers fa-fw" key={1}>
                <FontAwesomeIcon icon={faFile} size="xs" className="color-red" />
                <FontAwesomeIcon icon={faSearch} size="lg" className="color-black" />
            </span>,
            <FontAwesomeIcon key={2} icon={faCheckCircle} className="color-green" />
        ];

        this.loadStudentFileProposals = this.loadStudentFileProposals.bind(this);
        this.humanReadableFileSize = this.humanReadableFileSize.bind(this);
    }

    async loadStudentFileProposals() {
        this.setState({
            studentFileProposals: null
        })
        try {
            const studentFileProposals = await CamplaCoreService.getAllStudentFilesByStudentExamination(
                this.props.ex.examination._id
            );
            this.setState({ studentFileProposals });
        }catch (err){
            console.log(err);
        }
    }

    humanReadableFileSize(size) {
        const labels = ["B", "KB", "MB", "GB"];
        let ct = 0;
        while (size > 1024 && ct < labels.length) {
            size /= 1024;
            ct++;
        }
        return `${Math.round(size * 100) / 100} ${labels[ct]}`;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.showUploadDialog !== this.props.showUploadDialog){
            if (this.props.showUploadDialog){
                this.setState({
                    studentFileProposals: null,
                    showStudentFileProposals: false
                })
            }
        }
    }

    render() {
    const { t } = this.props;
    let hasInstructions = false;
    for (const i in this.props.ex.examination.instructions) {
      if (this.props.ex.examination.instructions[i].length > 0) {
        hasInstructions = true;
        break;
      }
    }
    const instructionsButton = hasInstructions ? (
      <Button
        className="footer-action-button btn btn-green btn-sm"
        style={{ float: "right" }}
        onClick={this.props.onShowInstructions}
      >
        <FontAwesomeIcon icon={faChalkboardTeacher} />
      </Button>
    ) : (
      ""
    );

    let documents = "";
    if (this.props.runningExamination
        && this.props.runningExamination !== "undefined"
        && this.props.runningExamination.isRunning
        && this.props.runningExamination.instanceId === this.props.ex.instance._id
        && this.props.runningExamination.documents.length > 0){
        const lecturerDocuments = this.props.runningExamination.documents.filter(doc => !doc.submitted);
        const studentDocuments = this.props.runningExamination.documents.filter(doc => doc.submitted);
        const lecturerDocumentsTable = lecturerDocuments.length > 0 ? (
            <div>
                <b>{t("ExaminationAccess.Documents.ExaminationDocuments")}:</b><br />
                <Table size="sm" className="mt-2">
                    <tbody>
                        {lecturerDocuments.map(doc => (
                            <tr>
                                <td>{doc.name}</td>
                                <td>
                                    <div className="floatRight">
                                        <Button href={`${window.lernstickBridgeBaseURL}/documents/${doc.id}`}
                                                target="_blank"
                                                className="btn-green btn-sm">
                                            <FontAwesomeIcon icon={faExternalLinkAlt} />
                                        </Button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        ) : "";
        const studentsDocumentsTable = studentDocuments.length > 0 ? (
            <div className={lecturerDocuments.length > 0 ? "mt-2" : ""}>
                <b>{t("ExaminationAccess.Documents.StudentsDocuments")}:</b><br />
                <Table size="sm" className="mt-2">
                    <tbody>
                    {studentDocuments.map(doc => (
                        <tr>
                            <td>{doc.name}</td>
                            <td>
                                <div className="floatRight">
                                    <Button href={`${window.lernstickBridgeBaseURL}/documents/${doc.id}`}
                                            target="_blank"
                                            className="btn-green btn-sm">
                                        <FontAwesomeIcon icon={faExternalLinkAlt} />
                                    </Button>
                                </div>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </Table>
            </div>
        ) : "";
        documents = <div>
            {lecturerDocumentsTable}
            {studentsDocumentsTable}
        </div>
    }

    const status = this.props.ex.examination.status;
    let icons;
    let examName;
    let startButton = "";
    switch (status) {
      case 10:
        icons = (
          <FontAwesomeIcon icon={faCircle} className="color-yellow mr-2" />
        );
        examName = (
          <span className="ml-2">{this.props.ex.examination.name}</span>
        );
        break;
      case 11:
        icons = (
          <FontAwesomeIcon icon={faCircle} className="color-green mr-2" />
        );
        examName = (
          <span className="ml-2">{this.props.ex.examination.name}</span>
        );
        startButton = (
          <Button
            className="footer-action-button btn btn-green btn-sm ml-1"
            style={{ float: "right" }}
            disabled={(this.props.runningExamination
            && this.props.runningExamination.instanceId === this.props.ex.instance._id
            && this.props.runningExamination.isRunning
            && this.props.runningExamination.examType !== "web")
            || this.props.startInstanceId === this.props.ex.instance._id}
            onClick={() => this.props.onDownload()}
          >
            {t("ExaminationAccess.StartExam")}
          </Button>
        );
        break;
      default:
        icons = (
          <FontAwesomeIcon icon={faCircle} className="color-black mr-2" />
        );
        examName = (
          <span className="ml-2">{this.props.ex.examination.name}</span>
        );
        break;
    }
    const studentFileProposalButton = this.props.ex.examinationRestrictions.allowStudentFiles ? (
        <Button
            className={this.state.showStudentFileProposals
                ? "footer-action-button btn btn-black btn-sm ml-1" : "footer-action-button btn btn-green btn-sm ml-1"}
            style={{ float: "right" }}
            onClick={() => {
                if (!this.state.showStudentFileProposals) this.loadStudentFileProposals();
                this.setState({showStudentFileProposals: !this.state.showStudentFileProposals});
            }}
        >
            <FontAwesomeIcon icon={faFile} />
        </Button>
    ) : "";
    const studentFileProposalList = this.props.ex.examinationRestrictions.allowStudentFiles ? (
        <Row>
            <Col>
                <Collapsible
                    open={this.state.showStudentFileProposals}
                >
                    {this.state.studentFileProposals && this.state.studentFileProposals.length > 0 ? (
                        <>
                            <b>{t(
                                "ExaminationAccess.UploadManagerDialog.Title"
                            )}</b> <br />
                            <ul style={{ listStyle: "none", padding: "0px" }}>
                                <li>
                                    <FontAwesomeIcon icon={faCheckCircle} className="color-green mr-2" />
                                    {t(
                                        "ExaminationAccess.UploadManagerDialog.FileOverviewTab.AcceptedFile"
                                    )}
                                </li>
                                <li>
                                          <span className="fa-layers fa-fw mr-2">
                                            <FontAwesomeIcon
                                                icon={faFile}
                                                size="xs"
                                                className="color-red"
                                            />
                                            <FontAwesomeIcon
                                                icon={faSearch}
                                                size="lg"
                                                className="color-black"
                                            />
                                          </span>
                                    {t(
                                        "ExaminationAccess.UploadManagerDialog.FileOverviewTab.FileUnderReview"
                                    )}
                                </li>
                            </ul>
                            <Table size="sm mt-2">
                                <thead>
                                <tr>
                                    <th>
                                        {t(
                                            "ExaminationAccess.UploadManagerDialog.FileOverviewTab.ColumnFilename"
                                        )}
                                    </th>
                                    <th>
                                        {t(
                                            "ExaminationAccess.UploadManagerDialog.FileOverviewTab.ColumnFileSize"
                                        )}
                                    </th>
                                    <th />
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.studentFileProposals.map((p, idx) => (
                                    <tr key={idx}>
                                        <td>{p.name}</td>
                                        <td>{this.humanReadableFileSize(p.size)}</td>
                                        <td>{this.fileState[p.isAccepted ? 1 : 0]}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        </>
                    ) : (this.state.studentFileProposals === null ? (
                        <FontAwesomeIcon icon={faCircleNotch} spin />
                    ) : <b>
                        {t("ExaminationAccess.UploadManagerDialog.FileOverviewTab.NoUploadsFound")}
                    </b>)}
                </Collapsible>
            </Col>
        </Row>
        ) : "";

    let out;
    if (
      this.props.ex.examinationRestrictions.allowStudentFiles &&
      (status === 1 || (status >= 50 && status <= 53))
    ) {
      out = (
          <>
              <Row className="align-items-center mb-1">
                  <Col>
                      {icons}
                      {t("ExaminationAccess.PrependExam")}:{examName}
                  </Col>
                  <Col>
                      {studentFileProposalButton}
                      {startButton}
                      <Button
                          className="footer-action-button btn btn-green btn-sm ml-1"
                          style={{ float: "right" }}
                          onClick={this.props.onUploadManager}
                      >
                          <FontAwesomeIcon icon={faUpload} />
                      </Button>
                      {instructionsButton}
                  </Col>
              </Row>
              {studentFileProposalList}
          </>
      );
    } else {
      out = (
          <>
              <Row className="align-items-center">
                  <Col>
                      {icons}
                      {t("ExaminationAccess.PrependExam")}:{examName}
                  </Col>
                  <Col>
                      {studentFileProposalButton}
                      {startButton}
                      {instructionsButton}
                  </Col>
              </Row>
              {studentFileProposalList}
              {documents !== "" ? (<Row className="align-items-center mt-1">
                  <Col>
                      {documents}
                  </Col>
              </Row>) : ""}
              {!this.props.isLastExamination ? (<Row className="mt-0 pt-0 mb-1 pb-0">
                  <Col><hr /></Col>
              </Row>) : ""}
          </>
      );
    }
    return <>{out}</>;
  }
}

export default withTranslation()(ExaminationTableItem);
